<template>
  <div id="app">
    <a-locale-provider :locale="locale">
      <router-view></router-view>
    </a-locale-provider>
  </div>
</template>

<script>
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN";
export default {
  name: "test-electron",
  data() {
    return {
      locale: zhCN,
    };
  },
  mounted() {
    
  },
};
</script>

<style>
/* CSS */
body,
html {
  font-size: 16px;
  min-width: 800px;
}
</style>